import { ReactNode } from 'react'
import {
  RenderButton,
  RenderDiv,
  RenderForm,
  RenderH1,
  RenderH2,
  RenderH3,
  RenderH4,
  RenderH5,
  RenderH6,
  RenderH,
  RenderLink,
  RenderMainDiv,
  RenderP,
  RenderForm2X3,
  RenderForm2X2,
  RenderFormMain,
} from './RenderFunction'
import { RenderExpressionInput } from './Components/RenderExpressionInput'
import { RenderInput } from './Components/RenderInput'

export type UiFromSpecFieldConfig = {
  ui_type: string
  renderComponent: (props: any) => ReactNode
}

export const currentFieldConfig: UiFromSpecFieldConfig[] = [
  {
    ui_type: 'INPUT',
    renderComponent: RenderInput,
  },
  {
    ui_type: 'MAIN_DIV',

    renderComponent: RenderMainDiv,
  },
  {
    ui_type: 'FORM_MAIN',

    renderComponent: RenderFormMain,
  },
  {
    ui_type: 'DIV',

    renderComponent: RenderDiv,
  },
  {
    ui_type: 'BUTTON',

    renderComponent: RenderButton,
  },
  {
    ui_type: 'P',

    renderComponent: RenderP,
  },
  {
    ui_type: 'FORM',

    renderComponent: RenderForm,
  },
  {
    ui_type: 'FORM2X3',

    renderComponent: RenderForm2X3,
  },
  {
    ui_type: 'FORM2X2',

    renderComponent: RenderForm2X2,
  },
  {
    ui_type: 'H1',

    renderComponent: RenderH1,
  },

  {
    ui_type: 'H2',

    renderComponent: RenderH2,
  },

  {
    ui_type: 'H3',

    renderComponent: RenderH3,
  },
  {
    ui_type: 'H4',

    renderComponent: RenderH4,
  },
  {
    ui_type: 'H5',

    renderComponent: RenderH5,
  },
  {
    ui_type: 'H6',

    renderComponent: RenderH6,
  },
  {
    ui_type: 'H',

    renderComponent: RenderH,
  },
  {
    ui_type: 'LINK',

    renderComponent: RenderLink,
  },
  {
    ui_type: 'INPUT_ADDON',

    renderComponent: RenderInput,
  },
  {
    ui_type: 'EXPRESSION_INPUT',
    renderComponent: RenderExpressionInput,
  },
]
